import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from './js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from './js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ComparableClass;
function Comparable() {
  if (ComparableClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Comparable');
    ComparableClass = $;
  }
  return ComparableClass;
}
//region block: exports
export {
  Comparable as Comparable198qfk8pnblz0,
};
//endregion

//# sourceMappingURL=Comparable.mjs.map
